import { useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { api, AUTH } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import AuthShell from "@/components/AuthShell";
import SiteFooter from "@/components/SiteFooter";
import { toast } from "sonner";

function defaultAccountRoute() {
  const host = window.location.hostname.toLowerCase();
  if (host === "merchant.ordrs.ai") return "/merchant";
  if (host === "provider.ordrs.ai") return "/provider";
  if (host === "auto.ordrs.ai") return "/autoaccount";
  if (host === "autoaccount.ordrs.ai") return "/autoaccount";
  if (host === "account.ordrs.ai") return "/autoaccount";
  return "/account";
}

export default function Signup() {
  const nav = useNavigate();
  const location = useLocation();
  const next = new URLSearchParams(location.search).get("next");
  const inviteToken = new URLSearchParams(location.search).get("invite");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e?.preventDefault();
    setBusy(true);
    try {
      const r = inviteToken
        ? await api.post("/auth/accept-invite", { token: inviteToken, name, password })
        : await api.post("/auth/signup", { name, email, password });
      AUTH.set(r.data.token, r.data.user);
      toast.success("Account created");
      nav(next && next.startsWith("/") ? next : defaultAccountRoute());
    } catch (e) { toast.error(e?.response?.data?.detail || "Signup failed"); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <AuthShell />
      <div className="max-w-md mx-auto px-6 py-16">
        <h1 className="text-4xl mb-2">Create your account.</h1>
        <p className="text-muted-foreground mb-8">{inviteToken ? "Set your password to join the business team." : "Free preview. No card. Upgrade only when you're ready to take real orders."}</p>
        <Card className="p-8">
          <form onSubmit={submit} className="space-y-4">
            <Input data-testid="signup-name" placeholder="Your name" value={name} onChange={e=>setName(e.target.value)} required/>
            {!inviteToken && (
              <Input data-testid="signup-email" placeholder="you@business.com" type="email" value={email} onChange={e=>setEmail(e.target.value)} required/>
            )}
            <Input data-testid="signup-password" placeholder="Password (8+ chars)" type="password" minLength={8} value={password} onChange={e=>setPassword(e.target.value)} required/>
            <Button data-testid="signup-submit" type="submit" disabled={busy} className="w-full h-11 font-bold">{busy?"Creating...":"Create free account"}</Button>
          </form>
          <p className="text-sm text-muted-foreground text-center mt-6">Already have one? <Link to="/login" className="text-primary font-bold">Sign in</Link></p>
        </Card>
      </div>
      <SiteFooter />
    </div>
  );
}
